import { apiPostModel, postApi } from '../../useApiHook';

export const postCreateOrEditClinicianGroup = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('CreateClinicianGroup', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};

export const disableClinicianGroup = (auth, entityModel, callback, errorCallback) => {
  const postModel = apiPostModel('DisableClinicianGroup', entityModel, callback, errorCallback);
  postApi(auth, postModel);
};
